import MarketingPageWrapper from '@/domain/Training/MarketingPageWrapper';
import MarketingHero from '@/domain/Training/MarketingHero';
import MarketingHighlightCopy from '@/domain/Training/MarketingHighlightCopy';
import MarketingContent from '@/domain/Training/MarketingContent';
import MarketingTrainers from '@/domain/Training/MarketingTrainers';
import MarketingFeatures from '@/domain/Training/MarketingFeatures';
import MarketingProgram from '@/domain/Training/MarketingProgram';
import MarketingPricing from '@/domain/Training/MarketingPricing';
import MarketingTestimonials from '@/domain/Training/MarketingTestimonials';
import MarketingFAQs from '@/domain/Training/MarketingFAQs';
import MarketingContact from '@/domain/Training/MarketingContact';
import client from '@/api/client';
import { trainingAgileCoachQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({
    query: trainingAgileCoachQuery,
    variables: {
      id: 'official-agile-coach-certification-training',
    },
  });

  return {
    props: {
      training: data?.training,
    },
  };
}

export default function TrainingMarketingPage({ training }) {
  const hasContent = training.content !== null;
  const hasTrainers = training.details.trainers !== null;
  const hasWhatIsLearned = training.details.whatIsLearned !== null;
  const hasProgramSubjects = training.details.programSubjects !== null;
  const hasTestimonials = training.details.testimonials !== null;
  const hasPricingTable = training.details_agile_coach !== null;
  const hasFAQs = training.details.faqs !== null;

  return (
    <MarketingPageWrapper>
      <MarketingHero
        heroCopy="Official Agile Coach"
        heroLead={
          <p className="leading-relaxed">
            El programa de entrenamiento&nbsp;
            <strong>más completo para hispanohablantes</strong>
            &nbsp;donde adquieres y desarrollas las competencias necesarias para
            ejercer como un&nbsp;
            <strong className="text-gray-900">Agile Coach</strong>.
          </p>
        }
        heroImage="w_710,h_910/v1610683730/personas/official-agile-coach-certification_ng96yw.png"
        heroImageAlt="Official Agile Coach Training"
        heroCTANormalClasses="bg-red-600"
        heroCTAHoverClasses="hover:bg-red-700"
        heroCTAFocusClasses="focus:bg-red-700 focus:ring-red-600 focus:ring-opacity-20"
        heroHighlighColor="text-red-600"
        heroBackgroundFrom="from-red-100"
        heroBackgroundTo="to-white"
        stripesBackgroundFrom="from-red-500"
        stripesBackgroundTo="to-transparent"
        stripesBackgroundDarkerFrom="from-red-700"
        stripesBackgroundDarkerTo="to-transparent"
        {...training.details}
      />
      <MarketingHighlightCopy>
        <p className="leading-relaxed">
          El programa&nbsp;
          <strong className="font-semibold text-white">
            Official Agile Coach
          </strong>
          &nbsp;es el único que te capacita para convertirte en un&nbsp;
          <strong className="font-semibold text-white">Experto Agile</strong>
          &nbsp;con liderazgo y conocimiento para ejecutar los procesos&nbsp;
          <strong className="font-semibold text-white">Lean-Agile</strong>
          &nbsp;en cualquier organización.
        </p>
      </MarketingHighlightCopy>
      {hasContent && <MarketingContent content={training.content} />}
      {hasTrainers && (
        <MarketingTrainers trainers={training.details.trainers} />
      )}
      {hasWhatIsLearned && (
        <MarketingFeatures features={training.details.whatIsLearned} />
      )}
      {hasProgramSubjects && (
        <MarketingProgram program={training.details.programSubjects} />
      )}
      {hasPricingTable && (
        <MarketingPricing
          {...training.details}
          {...training.details_agile_coach}
        />
      )}
      {hasTestimonials && (
        <MarketingTestimonials testimonials={training.details.testimonials} />
      )}
      {hasFAQs && <MarketingFAQs faqs={training.details.faqs} />}
      <MarketingContact />
    </MarketingPageWrapper>
  );
}
